import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/ConditionalMetaPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/ConditionalSpeedInsights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/InboundSourceCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/LateGA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/PageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/ScrollDepth.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/apple-icon.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/ConditionalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/legal/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkipToContentLink"] */ "/vercel/path0/app/components/SkipToContentLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/favicon.ico");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/opengraph-image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/twitter-image.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/components/DocumentShell.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-geist-sans\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/components/DocumentShell.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"display\":\"swap\",\"variable\":\"--font-geist-mono\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/components/DocumentShell.tsx\",\"import\":\"Source_Serif_4\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\",\"variable\":\"--font-source-serif-4\"}],\"variableName\":\"sourceSerif\"}");
